import { Box, Grid } from '@chakra-ui/react';
import { mapApiSearchContentResultsFromApiToVm } from '~/searchApi';

import { ContentPreviewWrapper } from './ContentPreviewWrapper';
import { SingleContent } from './SingleContent';
import {
  TalentContentProperties,
  talentContentGridProps,
} from './TalentContent';
import { getContentLink, getIsStoryExpired } from './utils';

export const TalentContentReadonly = ({
  customContent: existingContent,
}: TalentContentProperties) => {
  return (
    <Grid {...talentContentGridProps}>
      {mapApiSearchContentResultsFromApiToVm(existingContent)?.map(
        (content) => {
          const contentLink = getContentLink(content);
          const isStoryExpired = getIsStoryExpired(content);

          return (
            <Box
              key={content.contentId}
              height={309}
              borderRadius="lg"
              overflow="hidden"
              position="relative"
            >
              <ContentPreviewWrapper
                isStoryExpired={isStoryExpired}
                contentLink={contentLink}
              >
                <SingleContent content={content} />
              </ContentPreviewWrapper>
            </Box>
          );
        },
      )}
    </Grid>
  );
};
